import React, { Component, Children } from 'react'
import uuid from 'uuid'

class Editable extends Component {
  constructor(props) {
    super(props)
    this.id = uuid.v4()
  }
  static defaultProps = {
    editable: true
  }

  render() {
    const children = this.props.children
    return (
      children ? Children.only(this.props.children) : null
    )
  }
}

export default Editable


// WEBPACK FOOTER //
// ./app/javascript/app/site/components/editable/index.js